module.exports = __webpack_public_path__ + "static/media/Lfont1212c_L1B.19c9223d.otf";